import { CategoryItem } from './category-item.model';

export class MembershipType
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Custom mappings
            if (json['CategoryItems'])
            {
                this.CategoryItems = [];
                json['CategoryItems'].forEach(item => {
                    this.CategoryItems.push(new CategoryItem(item));
                });
            }
        }
    }

    Id: number;
    Name: string;
    CanUploadMedia = false;
    CategoryItems: CategoryItem[];
}
